<template>
  <div class="dynamic-input flex gap30" v-if="dataFieldToRender" :class="`input-field-${dataFieldToRender.type}`">
    <h3
      class="ignore-theme-style"
      v-if="(!noTitle && !dataFieldToRender.hideTitleFromUi && dataFieldToRender.title) || ((dataFieldToRender.type === 'SEPARATOR') && dataFieldToRender.title)"
    >{{tOrTitle(dataFieldToRender.title)}}</h3>
    <div
      class="input-container"
      :class="{
        'flex-1': dataField.type?.toUpperCase() !== 'CHECKBOX',
        [dataField.type]: true,
        'table-container flex': dataFieldToRender.type === 'TABLE',
        'flex align-center gap10': shouldRenderSectionTitleValueVisibilityToggle
      }"
    >
      <p v-if="cmpName === 'UNKNOWN'">UNKNOWN INPUT TYPE "{{dataFieldToRender.type}}"</p>
      <p v-else-if="cmpName === 'MESSAGE'">{{dataFieldToRender.message}}</p>
      <component
        v-else
        class="flex-1 dynamic-section"
        :is="cmpName" 
        ref="input"
        v-bind="propsToPass" 
        :value="value"
        :dataField="dataFieldToRender"
        :organization="organization"
        :parentItem="parentItem"
        :release="release"
        @change="val => $emit('input', val, basePath)"
        @input="val => $emit('input', val, basePath)"
      />

      <label
        v-if="shouldRenderSectionTitleValueVisibilityToggle"
        class="flex align-center gap10 ignore-theme-style"
      >
        <input
          type="checkbox"
          :checked="sectionTitleValueVisible"
          @change="ev => $emit('input', ev.target.checked, sectionTitleValueVisiblePath)"
        />
        <span>{{$t('organizationLocales.releaseTitleValueVisibility.showTitleValue')}}</span>
      </label>

      <div v-if="dataFieldToRender.type === 'ROW'" class="flex gap10 row-container">
        <DynamicInput
          v-for="field in dataFieldToRender.fields"
          :key="field.fieldName"
          :dataField="field"
          :basePath___="field.fieldName"
          :basePath="[basePath, field?.fieldName].filter(Boolean).join('.')"
          :organization="organization"
          :parentItem="parentItem"
          :release="release"
          :value="(field?.fieldName)? getVal(parentItem, [basePath, field?.fieldName].filter(Boolean).join('.')) : parentItem"
          @input="(val, path) => $emit('input', val, path)"
        />
      </div>
      <table v-if="dataFieldToRender.type === 'TABLE'" colspacing="5px" class="flex-1 width-content">
        <!-- <tr class="flexx align-center gap10" v-if="value && value.length">
          <td v-for="(field, idx) in dataFieldToRender.fields" :key="`${basePath}.${idx}.${field.title}`">
            <p class="flex-1">
              {{tOrTitle(field.title)}}
            </p>
          </td>
          <td class="flex-1"></td>
        </tr> -->
        <tr v-for="(currVal, idx) in value" :key="getRowKey(currVal, idx)" class="flexx align-center gap10">
          <td
            v-for="field in dataFieldToRender.fields.filter(c => !c.hidden)"
            :key="`${getRowKey(currVal, idx)}.${field.fieldName}`"
          >
            <DynamicInput
              class="flex-1"
              :dataField="field"
              :basePath="[basePath, idx+'', field.fieldName].filter(Boolean).join('.')"
              :value="getVal(currVal, field.fieldName) || ''"
              :organization="organization"
              :parentItem="parentItem"
              :release="release"
              @input="(val, path) => $emit('input', val, path || [basePath, idx+'', field.fieldName].filter(Boolean).join('.'))"
              :noTitle="true"
            />
          </td>
          <td>
            <div class="flex align-end">
              <TableActionBtns :allowEmptyArray="true" class="flex-1" :value="value" @input="val => $emit('input', val, basePath)" :idx="idx"/>
            </div>
          </td>
        </tr>
        <tr v-if="!(dataFieldToRender.singleItem && (value?.length > 0))">
          <td>
            <button class="btn big square width-content_ align-self-end" @click.prevent="$emit('input', [...(value || []), createNewItem(dataFieldToRender.fields)], basePath)"><div v-html="svgs.plus" class="svg-parrent"></div></button>
          </td>
        </tr>
      </table>
      <div v-if="dataFieldToRender.type === 'LIST'" class="flex column gap30 width-content">
        <div v-for="(currVal, idx) in value" :key="getRowKey(currVal, idx)" class="flex align-start_ space-between gap30">
          <div class="flex column gap20 flex-1">
            <!-- <div
              v-for="field in (!dataFieldToRender.fieldOpts?.length ? dataFieldToRender.fields : dataFieldToRender.fieldOpts.find(_c => _c.find(_ => (_.type === 'TYPE') && (_.defaultValue === currVal._listItemType) ))).filter(c => !c.hidden)"
              :key="`${basePath}.${idx}.${field.fieldName}`"
            > -->
              <DynamicInput
                v-for="field in (!dataFieldToRender.fieldOpts?.length ? dataFieldToRender.fields : dataFieldToRender.fieldOpts.find(_c => _c.find(_ => (_.type === 'TYPE') && (_.defaultValue === currVal._listItemType) ))).filter(c => !c.hidden)"
                :key="`${getRowKey(currVal, idx)}.${field.fieldName}`"
                class="flex-1"
                :dataField="field"
                :basePath="[basePath, idx+'', field.fieldName].filter(Boolean).join('.')"
                :value="getVal(currVal, field.fieldName) || ''"
                :organization="organization"
                :parentItem="parentItem"
                :release="release"
                @input="(val, path) => $emit('input', val, path || [basePath, idx+'', field.fieldName].filter(Boolean).join('.'))"
                :noTitle="false"
              />
              <hr style="border-width:0.1em;border-color:var(--clr-4-l-80)" v-if="idx < (value.length -1)"/>
            <!-- </div> -->
          </div>
          <div>
            <label
              v-if="isSingleLookSelectorVisible(currVal, idx)"
              class="landing2-singlelook-item-select flex align-center gap10"
            >
              <input
                type="checkbox"
                :checked="!!currVal?.singleLookSelected"
                @change="ev => onSingleLookItemToggle(ev.target.checked, idx)"
              />
              <span>{{tOrTitle('singleLookSelected')}}</span>
            </label>
            <TableActionBtns :allowEmptyArray="true" class="flex-1" :value="value" @input="val => $emit('input', val, basePath)" :idx="idx"/>
          </div>
        </div>
        <div v-if="!(dataFieldToRender.singleItem && (value?.length > 0))" class="flex align-center gap10">
          <button class="btn big square" @click.prevent="$emit('input', [...(value || []), !dataFieldToRender.fieldOpts?.length ? createNewItem(dataFieldToRender.fields) : createNewItem(dataFieldToRender.fieldOpts[$refs.listTypeSelect.val])], basePath)"><div v-html="svgs.plus" class="svg-parrent"></div></button>
          <FormInput ref="listTypeSelect" v-if="dataFieldToRender.fieldOpts?.length" type="select" :value="0" :items="dataFieldToRender.fieldOpts.map((_c, _idx) => ({ value: _idx, label: tOrTitle(_c.find(_ => _.type === 'TYPE').defaultValue)}))"/>
        </div>
      </div>
    </div>
    <p v-if="dataFieldToRender.helpText">{{tOrTitle(dataFieldToRender.helpText)}}</p>
    <!-- <div v-if="dataField.fields">
    </div> -->
  </div>
</template>

<script>
import { Utils } from '@/apps/common/modules/common/services/util.service';
import FormInput from '@/apps/common/modules/common/cmps/FormInput.vue';
// import FileInput from '@/apps/common/modules/common/cmps/FileInput.vue';
import { VueEditor, Quill } from 'vue2-editor'
import { createItemForDynamicForm } from '../../../common/services/dynamicFormService';
import ReleasePicker from './ReleasePicker.vue';
import ReleaseIdsPicker from './ReleaseIdsPicker.vue';
import FileUploader from '@/apps/common/modules/common/cmps/file/FileUploader.vue';
import MultipleFilePicker from './MultipleFilePicker.vue';
import ImageCrop from './ImageCrop.vue';
import TableActionBtns from '@/apps/common/modules/common/cmps/TableActionBtns.vue';
import { getSvgs } from '@/assets/images/svgs';


import evManager from '@/apps/common/modules/common/services/event-emmiter.service.js';
import DbSelect from '../../../../../common/modules/common/cmps/DbSelect.vue';

// Ensure "left" is persisted as an explicit Quill alignment class (`ql-align-left`)
// so it can override RTL defaults in both editor and landing rendering.
const QuillAlignClass = Quill.import('attributors/class/align')
QuillAlignClass.whitelist = ['left', 'center', 'right', 'justify']
Quill.register(QuillAlignClass, true)

export default {
  name: 'DynamicInput',
  props: {
    dataField: [Object],
    value: [Object, String, Array, Number, Boolean],
    basePath: [String],
    parentItem: [Object],
    release: [Object],
    noTitle: [Boolean],
    organization: [Object]
  },
  data() {
    return {
      propsToPass: {},
      cmpName: '',
      dataFieldToRender: {...this.dataField},
      svgs: getSvgs(),
      rowKeyMap: new WeakMap(),
      rowKeySeed: 0
    }
  },
  computed: {
    shouldRenderSectionTitleValueVisibilityToggle() {
      const base = (this.basePath || '').toString()
      return this.dataFieldToRender?.fieldName === 'title' && /^sections\.\d+\.title$/.test(base)
    },
    sectionTitleValueVisiblePath() {
      const base = (this.basePath || '').toString()
      return base.replace(/\.title$/, '.titleVisible')
    },
    sectionTitleValueVisible() {
      if (!this.shouldRenderSectionTitleValueVisibilityToggle) return true
      const val = this.getVal(this.parentItem, this.sectionTitleValueVisiblePath)
      return val !== false
    }
  },
  methods: {
    applyRtlDefaultsToRichTextEditor() {
      try {
        const editorRef = this.$refs.input
        const quill = editorRef?.quill
        if (!quill) return

        const plainText = `${quill.getText() || ''}`.replace(/\u200B/g, '').trim()
        const isEffectivelyEmpty = !plainText

        // Apply RTL defaults only for empty/new content.
        // Do NOT rewrite existing lines, otherwise user-set left/center formatting gets lost.
        if (isEffectivelyEmpty) {
          // Ensure toolbar direction reflects RTL even when there is no active text selection.
          // Quill uses current selection formats; with empty editor, selection can be undefined until first input.
          try {
            quill.setSelection(0, 0, 'silent')
          } catch (e) {}
          quill.format('direction', 'rtl', 'silent')
          quill.format('align', 'right', 'silent')
        }

        // Keep DOM direction aligned with Quill delta attributes
        if (quill.root) {
          quill.root.setAttribute('dir', 'rtl')
          quill.root.style.direction = 'rtl'
        }
      } catch (e) {}
    },
    decorateRichTextToolbarTitles() {
      try {
        const editorRef = this.$refs.input
        const quill = editorRef?.quill
        if (!quill) return false

        const toolbarModule = quill.getModule && quill.getModule('toolbar')
        const toolbarEl =
          toolbarModule?.container ||
          quill?.container?.querySelector?.('.ql-toolbar') ||
          quill?.root?.closest?.('.ql-container')?.querySelector?.('.ql-toolbar') ||
          quill?.root?.parentElement?.querySelector?.('.ql-toolbar')

        if (!toolbarEl) return false

        const setTitle = (el, title) => {
          if (!el || !title) return
          el.setAttribute('title', `${title}`)
          el.setAttribute('aria-label', `${title}`)
          el.setAttribute('data-tooltip', `${title}`)
        }

        const classTitleMap = {
          'ql-bold': 'Bold',
          'ql-italic': 'Italic',
          'ql-underline': 'Underline',
          'ql-strike': 'Strikethrough'
        }

        const buttonTitle = (btn) => {
          for (const cls of Object.keys(classTitleMap)) {
            if (btn.classList?.contains(cls)) return classTitleMap[cls]
          }

          // Quill toolbar buttons carry the chosen value as `value`/`data-value`.
          const v = btn.getAttribute('value') || btn.getAttribute('data-value') || btn.textContent?.trim() || ''

          if (btn.classList?.contains('ql-direction')) {
            return v === 'rtl' ? 'Direction: RTL' : 'Direction: LTR'
          }
          if (btn.classList?.contains('ql-align')) {
            if (v === 'center') return 'Align center'
            if (v === 'right') return 'Align right'
            if (v === 'justify') return 'Align justify'
            return 'Align left'
          }

          if (btn.classList?.contains('ql-list')) {
            return `List: ${v || 'item'}`
          }

          return v
        }

        const pickerItemTitle = (item) => {
          const v = item.getAttribute('data-value') || item.textContent?.trim()
          if (!v) return ''
          const picker = item.closest?.('.ql-picker')
          if (picker?.classList?.contains('ql-header')) return `Header: ${v}`
          if (picker?.classList?.contains('ql-direction')) return `Direction: ${v.toUpperCase()}`
          if (picker?.classList?.contains('ql-align')) return `Align: ${v}`
          return v
        }

        const labelTitle = (label) => {
          const picker = label.closest?.('.ql-picker')
          if (picker?.classList?.contains('ql-header')) return 'Header'
          if (picker?.classList?.contains('ql-direction')) return 'Text direction'
          if (picker?.classList?.contains('ql-align')) return 'Alignment'
          return label.textContent?.trim() || ''
        }

        toolbarEl.querySelectorAll('button').forEach((btn) => {
          const t = buttonTitle(btn)
          setTitle(btn, t)
        })

        toolbarEl.querySelectorAll('.ql-picker-label').forEach((label) => {
          const t = labelTitle(label)
          setTitle(label, t)
        })

        toolbarEl.querySelectorAll('.ql-picker-item').forEach((item) => {
          const t = pickerItemTitle(item)
          setTitle(item, t)
        })
        return true
      } catch (e) {}
      return false
    },
    setupRichTextToolbarEnhancements(retries = 12) {
      try {
        const editorRef = this.$refs.input
        const quill = editorRef?.quill
        if (!quill) {
          if (retries > 0) setTimeout(() => this.setupRichTextToolbarEnhancements(retries - 1), 120)
          return
        }
        const toolbarModule = quill.getModule && quill.getModule('toolbar')
        const toolbarEl =
          toolbarModule?.container ||
          quill?.container?.querySelector?.('.ql-toolbar') ||
          quill?.root?.closest?.('.ql-container')?.querySelector?.('.ql-toolbar') ||
          quill?.root?.parentElement?.querySelector?.('.ql-toolbar')
        if (!toolbarEl) {
          if (retries > 0) setTimeout(() => this.setupRichTextToolbarEnhancements(retries - 1), 120)
          return
        }

        const ok = this.decorateRichTextToolbarTitles()
        if (!ok && retries > 0) {
          setTimeout(() => this.setupRichTextToolbarEnhancements(retries - 1), 120)
          return
        }
        setTimeout(() => this.decorateRichTextToolbarTitles(), 80)
        setTimeout(() => this.decorateRichTextToolbarTitles(), 240)
        setTimeout(() => this.decorateRichTextToolbarTitles(), 700)
      } catch (e) {}
    },
    tOrTitle(subKey) {
      if (!subKey) return subKey;
      // const key = `releaseLocales.dataFields.${subKey}`;
      const key = `dataFieldsLocales.${subKey}`;
      return this.$te(key) ? this.$t(key) : subKey;
    },
    initCmpData() {
      let type = this.dataField.type || '';
      type = type.toUpperCase();
      if (['EMAIL', 'URL', 'VIDEOURL'].includes(type)) type = 'TEXT';
      if (type === 'IMAGEGALLERY') {
        type = 'TABLE';
        this.dataFieldToRender = {
          ...this.dataField,
          type: 'TABLE',
          fields: [
            // {
            //   type: 'TEXT',
            //   fieldName: 'src',
            //   hidden: true
            // },
            {
              title: this.$t('photo'),
              type: 'IMAGE',
              fieldName: '',
            },
            {
              title: this.$t('title'),
              type: 'TEXT',
              fieldName: 'title',
            },
            {
              title: this.$t('credit'),
              type: 'TEXT',
              fieldName: 'credit',
            },
          ]
        }
      }
      const _appendNewFile = (file) => {
        evManager.emit('file-uploaded', file);
      }
      let propsToPass = {...(this.dataField.propsToPass || {})};
      if (this.dataField.props) propsToPass = { ...propsToPass, ...this.dataField.props };
      switch (type) {
        case 'TEXT':
        case 'DATE':
        case 'NUMBER':
        case 'TEXTAREA':
        case 'CHECKBOX':
          this.propsToPass = { ...propsToPass, type: type.toLowerCase(), placeholder: this.tOrTitle(this.dataField.title) };
          this.cmpName = 'FormInput';
          break;
        case 'SELECT':
          this.propsToPass = { ...propsToPass, type: 'select', placeholder: this.tOrTitle(this.dataField.title), items: (this.dataField.options || []).map(c => ({ ...c, label: this.tOrTitle(c.label) })) };
          this.cmpName = 'FormInput';
          break;
        case 'SEPARATOR':
        // case 'SEPARATOR_BOLD':
          this.cmpName = 'hr';
          this.propsToPass = { ...propsToPass, style: `border-width:0.125em;border-color:var(--clr-4)` };
          break;
        case 'LIGHT_SEPARATOR':
          this.cmpName = 'hr';
          this.propsToPass = { ...propsToPass, style: 'border-width:1px;border-color:var(--clr-0);opacity:0.5' };
          break;
        case 'LONGRICHTEXT':
        case 'RICHTEXT':
          // Documented valid Quill/vue2-editor toolbar (full set).
          const defaultRichToolbar = [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
            // One RTL and one LTR command.
            [{ direction: 'rtl' }, { direction: 'ltr' }],
            [{ size: ['small', false, 'large', 'huge'] }],
            [{ color: [] }, { background: [] }],
            [{ font: [] }],
            ['link', 'image', 'video'],
            ['clean']
          ]
          this.propsToPass = {
            ...propsToPass,
            editorToolbar: propsToPass.editorToolbar || defaultRichToolbar
          }
          // Quill defaults to LTR unless direction format is applied.
          // Apply RTL defaults for release editor content.
          this.$nextTick(() => setTimeout(() => {
            this.applyRtlDefaultsToRichTextEditor()
            this.setupRichTextToolbarEnhancements()
          }, 10))
          this.cmpName = 'VueEditor';
          break;
        case 'TABLE':
        case 'ROW':
        case 'LIST':
          this.propsToPass = { ...propsToPass, hidden: true };
          this.cmpName = 'div';
          break;
        case 'RELEASES_SELECTOR': 
          this.cmpName = 'ReleasePicker'
          this.propsToPass = { ...propsToPass, organization: this.organization };
          break;

        case 'FILE':
        case 'VIDEO':
          this.cmpName = 'FileUploader';
          // Check for accept in: filter, or propsToPass.accept (which already includes props.accept from line 193)
          // Also check if field title or parent context suggests it's a video field
          const acceptFromFilter = this.dataField.filter && this.dataField.filter.trim() ? this.dataField.filter : null;
          
          // Check if this is a video field by title or parent context
          const fieldTitle = (this.dataField.title || '').toLowerCase();
          const isVideoField = type === 'VIDEO' || 
                               fieldTitle.includes('video') || 
                               fieldTitle === 'video' ||
                               this.basePath?.toLowerCase().includes('video');
          
          const acceptValue = acceptFromFilter || propsToPass.accept || (isVideoField ? 'video/*' : '');
          
          // Enable cloud selection for encrypted videos section
          const isEncryptedVideosSection = this.basePath?.includes('encryptedVideos') || 
                                           this.parentField?.fieldName === 'encryptedVideos';
          const enableCloudSelection = isEncryptedVideosSection && isVideoField;
          
          // Put accept AFTER propsToPass spread to ensure it takes precedence
          this.propsToPass = { 
            ...propsToPass, 
            accept: acceptValue, 
            uploadFolderName: this.organization._id, 
            parentData: {col: 'release', _id: this.release._id}, 
            onupload: file => _appendNewFile(file), 
            rootItem: this.release,
            enableCloudSelection: enableCloudSelection,
            sectionName: enableCloudSelection ? 'encryptedVideos' : '',
            fieldName: enableCloudSelection ? 'encryptedVideos' : ''
          };
          break;
        case 'IMAGE':
          this.cmpName = 'ImageCrop';
          this.propsToPass = { accept: this.dataField.filter || 'image/*', ...propsToPass, uploadFolderName: this.organization._id, parentData: {col: 'release', _id: this.release._id}, onupload: file => _appendNewFile(file), rootItem: this.release };
          break;

        // case 'FILE_SRC':
        //   this.cmpName = 'FileUploader';
        //   this.propsToPass = { ...propsToPass, accept: this.dataField.filter, onlySrc: true, uploadFolderName: this.organization._id };
        //   break;
        // case 'IMAGE_SRC':
        //   // this.cmpName = 'FileUploader';
        //   this.cmpName = 'ImageCrop';
        //   this.propsToPass = { ...propsToPass, viewAsImg: true, accept: this.dataField.filter, onlySrc: true, uploadFolderName: this.organization._id };
        //   break;
        // case 'IMAGEGALLERY':
        //   this.cmpName = 'MultipleFilePicker';
        //   this.propsToPass = { ...propsToPass, viewAsImg: true, isSingleItem: false, accept: this.dataField.filter };
        //   break;
        case 'SELECT_RELEASES_FROM_INNER_PARAM': // change to something like: SELECT_RELEASES_FROM_INNER_PARAM
          this.cmpName = 'ReleaseIdsPicker';
          this.propsToPass = { ...propsToPass, releases: this.parentItem[this.dataField.fromField], fromField: this.dataField.fromField };
          break;

        case 'MULTISELECT':
          this.cmpName = 'FormInput'
          this.propsToPass = { ...propsToPass, labelholder_: 'tags', type: 'multiselect', showVals: true, items: this.dataField.options  };
          break;

        // // BAD: single items in array;
        // case 'SINGLE-IMAGE_IN_ARRAY':
        //   // this.cmpName = 'ImageCrop';
        //   this.cmpName = 'MultipleFilePicker';
        //   this.propsToPass = { ...propsToPass, viewAsImg: true, isSingleItem: true, accept: this.dataField.filter, uploadFolderName: this.organization._id, parentData: {col: 'release', _id: this.parentItem._id} };
        //   break;
        // case 'FILEINARRAY':
        case 'VIDEOINARRAY':
          this.cmpName = 'MultipleFilePicker';
          this.propsToPass = { ...propsToPass, isSingleItem: true, accept: this.dataField.filter, uploadFolderName: this.organization._id, parentData: {col: 'release', _id: this.parentItem._id}, onupload: file => _appendNewFile(file), rootItem: this.release };
          break;

        case 'TYPE':
          // this.cmpName = 'FormInput';
          // this.propsToPass = { ...propsToPass, disabled: true, type: 'text', placeholder: this.tOrTitle(this.dataField.defaultValue) };
          this.cmpName = 'MESSAGE';
          this.dataFieldToRender.message = this.tOrTitle(this.dataField.defaultValue);
          // this.propsToPass = { ...propsToPass, message: this.tOrTitle(this.dataField.defaultValue) };
          break;


        // case 'IMAGEINARRAY':
        //   this.cmpName = 'MultipleFilePicker';
        //   this.propsToPass = { ...propsToPass, viewAsImg: true, isSingleItem: true, accept: this.dataField.filter };
        //   break;

        case 'LOGOSELECTION':
          this.cmpName = 'FormInput';
          const logoItems = this.organization?.logos?.map(c => {
            // Process the URL to ensure uploads/ prefix
            let processedUrl = c.url;
            if (c.url && c.url.includes('images.megaphon.co.il/') && !c.url.includes('images.megaphon.co.il/uploads/')) {
              processedUrl = c.url.replace('images.megaphon.co.il/', 'images.megaphon.co.il/uploads/');
            }
            return {value: c.url, img: processedUrl, label: c.title};
          }) || [];
          this.propsToPass = { ...propsToPass, type: 'select', items: logoItems };
          break;
        case 'SELECTIONWITHIMAGE': // change to somethong like: IMG_SELECTION_FOR_VIDEO_LINK
          this.cmpName = 'FormInput';
          const _getYoutubeVideoThumb = (url, index = 0) => {
            if (!url) return '';
            
            // Extract video ID from various YouTube URL formats
            let videoId = '';
            const patterns = [
              /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/,
              /youtube\.com\/v\/([^&\n?#]+)/,
              /youtube\.com\/watch\?.*v=([^&\n?#]+)/
            ];
            
            for (const pattern of patterns) {
              const match = url.match(pattern);
              if (match) {
                videoId = match[1];
                break;
              }
            }
            
            if (!videoId) return '';
            
            // YouTube provides 4 different thumbnail frames (0, 1, 2, 3)
            // These are automatically generated frames from different points in the video
            const frameIndex = Math.min(index, 3); // YouTube provides frames 0, 1, 2, 3
            
            // For the first option, try to get the highest quality thumbnail available
            // For other options, use the different frames (they're only available in standard quality)
            if (index === 0) {
              // Try maxresdefault first, but it's not always available
              // Fallback to hqdefault if maxresdefault doesn't exist
              return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
            } else {
              return `https://img.youtube.com/vi/${videoId}/${frameIndex}.jpg`;
            }
          };
          const videoUrl = Utils.getDeepVal(this.parentItem, this.basePath.replace(this.dataField.fieldName, this.dataField.linkedVideoField));
          this.propsToPass = { 
            ...propsToPass, 
            type: 'select', 
            items: Utils.range(4).map((_, idx) => {
              const currUrl = _getYoutubeVideoThumb(videoUrl, idx)
              return {value: currUrl, img: currUrl, label: `${this.$t('photo')} ${idx+1}`};
            })
          };
          break;
        
        
        case 'MESSAGE':
          this.cmpName = 'MESSAGE';
          break;
        case 'DB_SELECTION_SELECT':
          this.cmpName = 'DbSelect';
          this.propsToPass = { ...propsToPass, isMultiSelect: false, placeholder: this.tOrTitle(this.dataField.title) };
          break;
        case 'DB_SELECTION_MULTISELECT':
          this.cmpName = 'DbSelect';
          this.propsToPass = { ...propsToPass, isMultiSelect: true, placeholder: this.tOrTitle(this.dataField.title) };
          break;

        default: 
          this.cmpName = 'UNKNOWN';
          break;

        
      }
      // if (this.dataField.props) this.propsToPass = { ...this.propsToPass, ...this.dataField.props };
    },
    getVal(item, fieldPath) {
      return Utils.getDeepVal(item, fieldPath);
    },
    getRowKey(item, idx) {
      const fallback = `${this.basePath || 'row'}-${idx}`
      if (!item || typeof item !== 'object') return fallback

      if (this.rowKeyMap.has(item)) return this.rowKeyMap.get(item)

      const candidate = item.fileId || item._id || item.id || item.src || item.title || item.name
      if (candidate !== undefined && candidate !== null && candidate !== '') {
        const type = typeof candidate
        if (type === 'string' || type === 'number') {
          const normalized = `${candidate}`
          this.rowKeyMap.set(item, normalized)
          return normalized
        }
      }

      const generated = `${this.basePath || 'row'}-${Date.now()}-${this.rowKeySeed++}`
      this.rowKeyMap.set(item, generated)
      return generated
    },
    createNewItem(dataFields) {
      return createItemForDynamicForm(dataFields);
    },
    isTextItemsSubItemsList() {
      const base = `${this.basePath || ''}`
      return this.dataFieldToRender?.type === 'LIST' && /^sections\.\d+\.textItems$/.test(base)
    },
    isSingleLookModeEnabledForCurrentList() {
      if (!this.isTextItemsSubItemsList()) return false
      const sectionBasePath = `${this.basePath}`.replace(/\.textItems$/, '')
      const isSingleLook = !!this.getVal(this.parentItem, `${sectionBasePath}.singleLook`)
      const isSubitemsLook = !!this.getVal(this.parentItem, `${sectionBasePath}.subitemsLook`)
      return isSingleLook && !isSubitemsLook
    },
    isSingleLookSelectorVisible(currVal) {
      if (!this.isSingleLookModeEnabledForCurrentList()) return false
      return !!currVal
    },
    onSingleLookItemToggle(isChecked, idx) {
      const list = Array.isArray(this.value) ? this.value : []
      const nextList = list.map((item, itemIdx) => ({
        ...(item || {}),
        singleLookSelected: isChecked ? (itemIdx === idx) : false
      }))
      this.$emit('input', nextList, this.basePath)
    }
  },
  mounted() {
    this.initCmpData();
  },
  components: { 
    FormInput,
    VueEditor,
    ReleasePicker,
    ReleaseIdsPicker,
    FileUploader,
    MultipleFilePicker,
    TableActionBtns,
    ImageCrop,
    DbSelect
    // FileInput
  },
}
</script>

<style lang="scss">
@import '@/assets/styles/global/index';
.megaphon-app {
  .dynamic-input {

    // h3 {
    //   color: var(--clr-0);
    // }
    &.input-field-SEPARATOR, .input-field-SEPARATOR_BOLD {
      h3 {
        color: var(--clr-4);
      }
    }

    max-width: 100%;
    // .dynamic-section, .input-container {
    //   width: 100%;
    //   // max-width: 100%;
    //   max-width: 90vw;
    //   overflow-x: auto;
    // }
    .row-container {
      // max-width: 100%;
      .dynamic-input {
        flex-direction: column !important;
        gap: em(5px);
      }
      @media (max-width: $small-screen-break) {
        // flex-direction: column;
        flex-wrap: wrap;
      }
    }
    .table-container {
      width: 100%;
      max-width: 90vw;
      // max-width: 100%;
      // overflow-x: auto;
      table {
        // border-spacing: em(10px);
        width: 100%;
        // overflow-x: auto;
        td {
          padding: em(5px);
          // vertical-align: top;
          vertical-align: middle;
        }
      }
    }
    .quillWrapper {
      @media (max-width: $small-screen-break) {
        max-width: 90vw; // TODO: 95;
        overflow-x: auto;
        margin: 0 auto;
      }
    }
    @media (max-width: $small-screen-break) {
      flex-direction: column;
      gap: em(10px);
    }
  }
}
</style>